import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import VisitorsTable from "../../components/VisitorsTable";
import { logger } from "../../utils/logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VisitorsPage = () => {
  const { sessions: defaultSessions, fetchSessions } = useOutletContext();
  const [activeVisitorsSessions, setActiveVisitorsSessions] = useState([]);

  // Fetch sessions with VisitorsPage filter (only currently active visitors)
  const fetchActiveVisitors = async () => {
    try {
      const accessToken = localStorage.getItem('access_token');
      if (!accessToken) return;

      const response = await axios.get(`${API}/sessions?filter_mode=active_visitors`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      setActiveVisitorsSessions(response.data || []);
    } catch (error) {
      logger.error("Error fetching active visitors:", error);
      // Fallback to default sessions if fetch fails
      setActiveVisitorsSessions(defaultSessions);
    }
  };

  useEffect(() => {
    fetchActiveVisitors();
  }, [defaultSessions]);

  // Use activeVisitorsSessions for VisitorsPage (filtered to only currently active)
  const sessions = activeVisitorsSessions;

  useEffect(() => {
    logger.log('[VisitorsPage] Data received - sessions:', sessions?.length);
  }, [sessions]);

  return (
    <div className="h-full overflow-y-auto p-6">
      <VisitorsTable
        sessions={sessions}
        onRefresh={fetchActiveVisitors}
      />
    </div>
  );
};

export default VisitorsPage;
